<template>
  <div>
    <div class="pb-6 flex justify-between items-center">
      <div class="flex items-center">
        <div class="mr-2">
          <el-input placeholder="search video name" v-model="filter.q" @change="searchVideos" ></el-input>
        </div>
        <Button @clicked="searchVideos" label="Apply"/>
        <button class="p-2" ><font-awesome-icon :icon="['fas', 'sync']" @click="resetVideos" /></button>
      </div>
      <Button @clicked="add" label="Add Videos" variant="outline-primary"/>
    </div>
    <data-tables-server ref="tableVideos" :data="data" :total="total" :pagination-props="{ background: true, pageSizes: [displayingItem] }" @query-change="onChangeTable" >
      <el-table-column v-for="title in titles" :prop="title.prop.field" :label="title.label" :key="title.prop.field" sortable="custom">
      </el-table-column>
      <el-table-column  label="Publish" class="text-center" width="100px" >
        <template slot-scope="scope">
          <label
            :for="'toogle'+scope.row.id"
            class="flex items-center"
            :class="'cursor-pointer'"
            style="height: 50px;"
          >
            <!-- toggle -->
            <div class="relative m-auto">
              <!-- input -->
              <input
                :id="'toogle'+scope.row.id"
                type="checkbox" v-model="scope.row.published"
                @change="submitPublished(scope.row)"
                class="hidden"
              />
              <!-- line -->
              <div
                class="toggle__line w-10 h-4 bg-gray-400 rounded-full shadow-inner"
              ></div>
              <!-- dot -->
              <div
                class="toggle__dot absolute w-6 h-6 bg-white rounded-full shadow inset-y-0 left-0"
              ></div>
            </div>
            <!-- label -->
          </label>
        </template>
      </el-table-column>
      <el-table-column label="Actions" align="right" min-width="100px">
        <template slot-scope="scope">
          <div class="static inline-block text-left container-action">
            <VueCustomTooltip label="Edit" :position="'is-left'">
              <button @click="edit(scope.row)" class="p-2 w-8 mr-2 mb-2 rounded bg-green-400 hover:bg-green-500 focus:outline-none" >
                <font-awesome-icon class="text-white" :icon="['fa', 'pencil-alt']" />
              </button>
            </VueCustomTooltip>
            <VueCustomTooltip label="Delete" :position="'is-left'">
              <button @click="deleteVideos(scope.row)" class="w-8 mr-2 mb-2 p-2 rounded bg-red-500 hover:bg-red-600 focus:outline-none" >
                <font-awesome-icon class="text-white" :icon="['fa', 'trash-alt']" />
              </button>
            </VueCustomTooltip>
          </div>
        </template>
      </el-table-column>
    </data-tables-server>
    <ModalDialog
      ref="addSong"
      :isShowingModal="isShowingModalForm"
      :title="titleModal"
      @toggleModal="isShowingModalForm = !isShowingModalForm"
      @save="submitFormVideos"
      :labelSubmit="'Submit'"
    >
      <template slot="body" >
        <VideosForm
          ref="videosForm"
          :toggle-reset="isShowingModalForm"
          :video-id="videoId"
          :channel-id="channelId"
          @on-submit-video="onSubmitForm"
        />
      </template>
    </ModalDialog>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import ModalDialogDetail from '@/components/Common/ModalDialogDetail';
import ModalDialog from '@/components/Common/ModalDialog';
import VueCustomTooltip from '@adamdehaven/vue-custom-tooltip';
import moment from 'moment';
import Vue from 'vue';
import helpersMixin from '@/mixins/helpers.mixins';
import VideosForm from '@/views/MissionsVideos/Videos/VideosForm';
import { Button } from '@/components/Layout/Form';

const initialStateVideos = {
  id: null,
  name: '',
  category: null,
  language: null,
  description: '',
  tags: '',
  avatar: null,
  video: null,
};
export default {
  name: 'TabVideos',
  mixins: [helpersMixin],
  props: {
    channel: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      channelId: Number(this.$route.params.channelId),
      isShowingModalForm: false,
      typeModal: 'add',
      utc_offset: Math.floor(moment().utcOffset() / 60),
      data: [],
      total: 0,
      displayingItem: 20,
      titles: [
      {
        prop: {
          field: 'name',
        },
        label: 'Video Name',
      },
      {
        prop: {
          field: 'type',
        },
        label: 'Type',
      },
      {
        prop: {
          field: 'duration',
        },
        label: 'Duration',
      },
      {
        prop: {
          field: 'created_at',
        },
        label: 'Upload Date',
      }
      ],
      filter: {
        per_page: 20,
        q: '',
        sortorder: 'desc',
        sortby: 'id',
        page: 1,
      },
      selectedRow: { ...initialStateVideos },
      videoId: null,
    };
  },
  async mounted() {
    await this.searchVideos();
  },
  computed: {
    ...mapGetters('AuthModule', ['isSuperAdmin', 'isAdmin', 'isOps', 'isFinance']),
    ...mapGetters('MissionsVideosModule', ['listVideos', 'totalListVideos', 'listCategoryVideos']),
    titleModal() {
      return this.typeModal === 'add' ? 'Add Videos' : 'Edit Videos';
    },
  },
  watch: {
    listVideos: {
      immediate: true,
      // eslint-disable-next-line no-unused-vars
      async handler(val) {
        await this.refineData();
      },
    },
  },
  methods: {
    ...mapActions('MissionsVideosModule', ['requestListVideos', 'requestAddVideos', 'requestDetailChannel',
      'requestEditVideos', 'requestDeleteVideos', 'requestDetailVideos', 'requestPublishVideos', 'requestListCategoryVideos']),
    ...mapActions('AppSettingModule', ['requestListCountry']),
    async searchVideos() {
      await this.requestListVideos({ data: { id: this.channelId }, filter: this.filter });
    },
    async resetVideos() {
      this.$refs.tableVideos.$refs.elTable.clearSort();
      this.filter = {
        per_page: 20,
        q: '',
        sortorder: 'desc',
        sortby: 'id',
        page: 1,
      };
      this.searchVideos();
    },
    refineData() {
      if (this.listVideos) {
        this.total = this.totalListVideos;
        this.data = this.listVideos.map((videos) => {
          const categories = videos.category.length > 0 ? videos.category.map(c => c.name).join(', ') : '-';
          return {
            ...videos,
            duration: this.secToMinFormat(videos.duration),
            category_name: categories,
            type: videos.type === 'podcast' ? 'Podcast' : 'Mission',
            created_at: moment(videos.created_at)
              .format('YYYY-MM-DD HH:mm:ss'),
          };
        });
      }
    },
    async onChangeTable(queryInfo) {
      if (queryInfo.type === 'init') return;
      const pageSize = queryInfo.pageSize;
      this.displayingItem = pageSize;
      const page = queryInfo.page;
      let sortby = queryInfo.sort.prop;
      let sortorder = queryInfo.sort.order === 'descending' || typeof (queryInfo.sort.order) === 'undefined' ? 'asc' : 'desc';
      if (typeof (sortby) === 'undefined') {
        sortby = 'id';
      }
      sortorder = queryInfo.sort.order === 'descending' || typeof (queryInfo.sort.order) === 'undefined' ? 'asc' : 'desc';
      this.filter.sortorder = sortorder;
      this.filter.sortby = sortby;
      this.filter.page = page;
      await this.requestListVideos({ data: { id: this.channelId }, filter: this.filter });
    },
    add() {
      this.videoId = null;
      this.typeModal = 'add';
      this.isShowingModalForm = true;
    },
    edit(row) {
      this.videoId = row.id;
      this.typeModal = 'edit';
      this.isShowingModalForm = true;
    },
    async detail(id) {
      const detail = await this.requestDetailVideos({
        id,
      });
      console.log(detail);
    },
    async submitPublished(row) {
      await this.requestPublishVideos({
        id: row.id,
        published: row.published,
      });
      await this.searchVideos();
    },
    deleteVideos(row) {
      Vue.swal({
        title: 'Delete Data!',
        text: `Are you sure to delete videos: ${row.name}`,
        icon: 'warning',
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        showCancelButton: true,
      }).then(async (result) => {
        if (result.value) {
          await this.requestDeleteVideos({
            id: row.id,
          });
          this.searchVideos();
          this.$swal('Deleted', `You successfully delete videos: ${row.name}`, 'success');
        }
      });
    },
    async onSubmitForm() {
      this.isShowingModalForm = false;
      await this.searchVideos();
    },
    async submitFormVideos() {
      await this.$refs.videosForm.submit();
    },
  },
  components: {
    VideosForm,
    ModalDialogDetail,
    ModalDialog,
    VueCustomTooltip,
    Button,
  },
}
</script>

<style scoped>
.toggle__dot {
  top: -.25rem;
  left: -.25rem;
  transition: all 0.3s ease-in-out;
}

input:checked ~ .toggle__dot {
  transform: translateX(100%);
  background-color: #48bb78;
}
</style>



// WEBPACK FOOTER //
// src/views/MissionsVideos/Channel/TabVideos.vue